// src/components/LinkAccountInvite.jsx
import React, { useState } from 'react'
import {
    Container,
    Box,
    FormControl,
    FormLabel,
    Input,
    Button,
    Heading,
    Text,
    VStack,
    useToast,
    useColorModeValue,
} from '@chakra-ui/react'
import useHasPermission from "../../../hooks/useHasPermission"
import {useNotification} from "../../../contexts/NotificationContext"
import axiosInstance from "../../../api/axiosInstance"
import { useTranslation } from 'react-i18next'


export default function LinkAccountInvite() {
    const { t } = useTranslation()
    const tr = (key, defaultValue) => t(key, { defaultValue })
    const isPremium = useHasPermission('premium')
    const [email, setEmail] = useState('')
    const [error, setError] = useState('')
    const toast = useToast()
    const { addNotification, addErrorNotifications } = useNotification()
    const cardBg = useColorModeValue('white', 'navy.800')

    if (!isPremium) {
        return (
            <Container py={8}>
                <Text>{tr('linkAccount.premiumRequired', 'You need a premium account to invite others.')}</Text>
            </Container>
        )
    }

    const handleSubmit = async e => {
        e.preventDefault()
        setError('')

        try {
            const { data } = await axiosInstance.post('/accounts/invite', { email })
            addNotification(data.message, 'success')
            setEmail('')
        } catch (err) {
            const msg = err.response?.data?.error || tr('linkAccount.messages.failedInvite', 'Failed to send invite')
            setError(msg)
            addErrorNotifications(err.response?.data)
        }
    }

    return (
        <Container maxW="lg" py={8} mt={20}>
            <Box bg={cardBg} shadow="md" borderRadius="md" p={6}>
                <Heading size="lg" mb={6} textAlign="center">
                    {tr('linkAccount.title', 'Link one of your accounts')}
                </Heading>
                <Box as="form" onSubmit={handleSubmit}>
                    <VStack spacing={4}>
                        <FormControl isRequired>
                            <FormLabel>{tr('linkAccount.inviteeEmail', 'Invitee Email')}</FormLabel>
                            <Input
                                type="email"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                placeholder={tr('linkAccount.placeholders.email', 'user@example.com')}
                            />
                        </FormControl>
                        <Button type="submit" colorScheme="blue" width="full" isDisabled={!email}>
                            {tr('linkAccount.sendInvite', 'Send Invite')}
                        </Button>
                        {error && (
                            <Text color="red.500" textAlign="center">
                                {error}
                            </Text>
                        )}
                    </VStack>
                </Box>
            </Box>
        </Container>
    )
}